<template>
  <v-card
    elevation="0"
    class="card-box-shadow pa-0 w-100 h-100"
    style="border-radius: 10px; overflow-y: auto"
  >
    <v-card-title class="px-3 py-2 d-flex justify-space-between">
      <h5 class="text-caption mr-1 font-weight-bold">Order Details</h5>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-subtitle>
      <v-row no-gutters>
        <v-col cols="12" class="pb-1" v-if="dataObj.customer_name">
          <BaseLabel
            icon="mdi-map-marker"
            :text="dataObj.customer_address"
            label="address"
            tooltipLabel="address"
          />
        </v-col>
        <v-col cols="6" class="pb-1" v-if="dataObj.location_id">
          <BaseLabel
            icon="mdi-book-marker"
            :text="dataObj.location_id"
            label="Location Id"
            tooltipLabel="Location ID"
          />
        </v-col>
        <v-col cols="6" class="pb-1" v-if="dataObj.contact_person">
          <BaseLabel
            icon="mdi-account-box"
            :text="dataObj.contact_person"
            label="Contact Person"
            tooltipLabel="Customer person"
          />
        </v-col>
        <v-col cols="6" class="pb-1" v-if="dataObj.payment_type">
          <BaseLabel
            icon="mdi-cash"
            :text="dataObj.payment_type"
            label="Payment Type"
            tooltipLabel="Payment Type"
          />
        </v-col>
        <v-col cols="6" class="pb-1" v-if="dataObj.order_value">
          <BaseLabel
            icon="mdi-cash-multiple"
            :text="dataObj.order_value"
            label="Order value"
            tooltipLabel="Order Value"
          />
        </v-col>
      </v-row>
    </v-card-subtitle>
  </v-card>
</template>

<script>
import TripTooltipWithIcon from "@/components/ModuleBasedComponents/Trip/TripTooltipWithIcon.vue";
import BaseLabel from "@/components/BaseComponents/BaseLabel.vue";
export default {
  components: {
    TripTooltipWithIcon,
    BaseLabel,
  },
  props: {
    dataObj: {
      required: true,
    },
  },
};
</script>